import { useSyncExternalStore } from "react";

let failed = false;
const listeners = new Set<() => void>();

export const setArivaHeaderFailed = (value: boolean) => {
  if (failed === value) return;
  failed = value;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Whether the ARIVA header failed to load, leaving the app to offer its own logout. */
export const useArivaHeaderFailed = () =>
  useSyncExternalStore(subscribe, () => failed);
